import { render, staticRenderFns } from "./CreateTrainee.vue?vue&type=template&id=29136afb"
import script from "./CreateTrainee.vue?vue&type=script&lang=js"
export * from "./CreateTrainee.vue?vue&type=script&lang=js"
import style0 from "./CreateTrainee.vue?vue&type=style&index=0&id=29136afb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports